import React, { useState } from "react";
import Modal, { modalStyles as m } from "./Modal";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { phpSaveInstantPo } from "../data/api";
import { updateLocalStock } from "../data/queries";

// Android outOfStockDialog → showDialogUpdateQuantity (STOCK_PROMPT register setting): an add that
// hits ZERO stock offers to update the on-hand quantity right here — productapi/save_instant_po with
// description "stockprompt" — and on success the product is added to the cart as originally asked.
export default function StockPromptModal({ product, variant, onUpdated, onClose }) {
  const [qty, setQty] = useState("");
  const [busy, setBusy] = useState(false);
  const name = (variant ? `${product.title} ${variant.name}` : product.title) || "Product";
  const price = variant ? variant.price : product.costperItem ?? product.cost_per_item ?? product.price;

  const update = async () => {
    const q = Number(qty);
    if (!(q > 0)) return ToastifyAlert("Enter a valid quantity", "error");
    if (typeof navigator !== "undefined" && navigator.onLine === false)
      return ToastifyAlert("No internet connection. Quantity can't be updated.", "error"); // Android noInternetCantUpdateQty
    setBusy(true);
    try {
      const res = await phpSaveInstantPo({ productId: product.id, variantId: variant ? variant.variantId : "", qty: q, price });
      if (!res || !(res.status === true || String(res.status) === "1" || String(res.status).toLowerCase() === "true")) {
        return ToastifyAlert((res && res.message) || "Quantity update failed", "error");
      }
      await updateLocalStock(product.id, variant ? variant.variantId : "", q);
      onUpdated(q);
    } catch {
      ToastifyAlert("Quantity update failed", "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Update quantity" onClose={onClose}>
      <div style={m.label}>{name} are Out of Stock.</div>
      <div style={{ ...m.label, marginTop: 12 }}>Quantity</div>
      <input
        style={m.input}
        inputMode="numeric"
        autoFocus
        value={qty}
        onChange={(e) => setQty(e.target.value.replace(/[^\d]/g, ""))}
        onKeyDown={(e) => e.key === "Enter" && update()}
        placeholder="0"
      />
      <button style={m.primary} disabled={busy} onClick={update}>{busy ? "Updating…" : "Update"}</button>
      <button style={m.ghost} disabled={busy} onClick={onClose}>Cancel</button>
    </Modal>
  );
}
